export function getAuthToken(skipOrg = false) {
  const authToken = JSON.parse(localStorage.getItem('authToken'))
  return authToken
}
